<template>



    <div style="padding: 15px 15px">
      <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
        <el-form-item>
          <el-button type="primary" @click="cleanGenDanLog">{{
              $t("Clean(跟单)")
            }}</el-button>
  
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" @click="cleanTipLog">{{
              $t("Clean(小费)")
            }}</el-button>
  
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" @click="cleanDevLog">{{
              $t("Clean(DEV)")
            }}</el-button>
  
        </el-form-item>
        <el-form-item>
          <span>连接状态:{{ this.socketStatus }}</span>
        </el-form-item>
      </el-form>
  
      <div class="tables-container table-bottom">
        <el-table :data="genDanList" :row-style="{ height: '0' }" :cell-style="{ padding: '5px' }" border
                  class="table-left">
          <!-- 跟单监控 -->
          <el-table-column width="100px" :label="$t('操作')">
            <template v-slot="scope">
              <el-button size="mini" round @click="deleteGenDanList(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="waller" width="600px" :label="$t('钱包')">
            <template slot-scope="scope">
              <span> {{ getSameCaTip(scope.row.ca) }}</span>
              <span class="color-round" :style="{ backgroundColor: getBackgroundColor(scope.row.ca) }"></span>
              <a :href="`https://gmgn.ai/sol/address/${scope.row.waller}`" target="_blank"
                 :class="'link-color'">
                {{ scope.row.waller }}
              </a>
              <span v-if="scope.row.isRead === 1" style="color: red;">读</span>
              <el-button size="mini" round @click="copyValue(scope.row.waller)">复制</el-button>
              <el-button size="mini" round @click="fetchDataV1(scope.row.waller, scope.$index)">Log</el-button>
            </template>
          </el-table-column>
  
          <el-table-column prop="ca" width="500px" :label="$t('CA地址')">
            <template slot-scope="scope">
              <a :href="`https://gmgn.ai/sol/token/${scope.row.ca}`" target="_blank" :class="'link-color'">
                {{ scope.row.ca }}
              </a>
              <el-button size="mini" round @click="copyValue(scope.row.ca)">复制</el-button>
            </template>
          </el-table-column>
  
  
  
          <el-table-column prop="num" :label="$t('出现次数')">
          </el-table-column>
        </el-table>
      </div>
  
      <!-- 高小费 -->
      <div class="tables-container table-bottom">
        <el-table :data="tipList" width="100px" :row-style="{ height: '0' }" :cell-style="{ padding: '5px' }" border
                  class="table-left">
          <el-table-column :label="$t('操作')">
            <template v-slot="scope">
              <el-button size="mini" round @click="deleteTipList(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="waller" width="600px" :label="$t('钱包')">
            <template slot-scope="scope">
              <a :href="`https://gmgn.ai/sol/address/${scope.row.waller}`" target="_blank"
                 :class="'link-color'">
                {{ scope.row.waller }}
              </a>
              <el-button size="mini" round @click="copyValue(scope.row.waller)">复制</el-button>
              <el-button size="mini" round @click="fetchDataV2(scope.row.waller, scope.row.ca)">查询</el-button>
            </template>
          </el-table-column>
  
          <el-table-column prop="ca" width="500px" :label="$t('CA地址')">
            <template slot-scope="scope">
              <span class="color-round" :style="{ backgroundColor: getSameCaColor(scope.row.ca,genDanList) }"></span>
              <a :href="`https://gmgn.ai/sol/token/${scope.row.ca}`" target="_blank" :class="'link-color' ">
                {{ scope.row.ca }}
              </a>
              <el-button size="mini" round @click="copyValue(scope.row.ca)">复制</el-button>
            </template>
          </el-table-column>
  
  
  
          <el-table-column prop="amount" :label="$t('小费')">
          </el-table-column>
          <el-table-column prop="mark" :label="$t('标记')">
          </el-table-column>
          <el-table-column prop="signature" :label="$t('HASH')">
            <template slot-scope="scope">
              <a :href="`https://solscan.io/tx/${scope.row.signature}`" target="_blank" :class="'link-color'">
                {{ 'HASH' }}
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
  
      <!-- DEV -->
      <div class="tables-container table-bottom">
        <el-table :data="devList" width="100px" :row-style="{ height: '0' }" :cell-style="{ padding: '5px' }" border
                  class="table-left">
          <el-table-column :label="$t('操作')">
            <template v-slot="scope">
              <el-button size="mini" round @click="deleteDevList(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="waller" width="600px" :label="$t('钱包')">
            <template slot-scope="scope">
              <a :href="`https://gmgn.ai/sol/address/${scope.row.waller}`" target="_blank"
                 :class="'link-color'">
                {{ scope.row.waller }}
              </a>
              <el-button size="mini" round @click="copyValue(scope.row.waller)">复制</el-button>
              <el-button size="mini" round @click="fetchDataV2(scope.row.waller, scope.row.ca)">查询</el-button>
            </template>
          </el-table-column>
  
          <el-table-column prop="ca" width="500px" :label="$t('CA地址')">
            <template slot-scope="scope">
              <a :href="`https://gmgn.ai/sol/token/${scope.row.ca}`" target="_blank" :class="'link-color'">
                {{ scope.row.ca }}
              </a>
              <el-button size="mini" round @click="copyValue(scope.row.ca)">复制</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <!-- 弹窗 -->
      <el-dialog :visible.sync="devLogShow" width="1500px" center close-on-click-modal v-if="devLogShow">
        <div style="margin-bottom: 10px">
          <a :href="`https://gmgn.ai/sol/address/${tempWaller}`" target="_blank" :class="'link-color'">
            查询地址：{{ tempWaller }}
          </a>
        </div>
        <el-table :data="genDanResponseList" v-loading="loading" :row-style="{ height: '0' }"
                  :cell-style="{ padding: '5px' }" border class="table-left">
          <el-table-column width="600px" prop="ca" :label="$t('CA地址')">
            <template slot-scope="scope">
              <a :href="`https://gmgn.ai/sol/token/${scope.row.ca}`" target="_blank" :class="'link-color'">
                {{ scope.row.ca }}
              </a>
              <el-button size="mini" round @click="copyValue(scope.row.ca)">复制</el-button>
              <el-button size="mini" round @click="fetchData(scope.row.address, scope.row.ca)">查询</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="lastBuyTime" :label="$t('时间')">
          </el-table-column>
          <el-table-column prop="buyAmountTotal" :label="$t('尾巴买入金额(sol)')">
          </el-table-column>
          <el-table-column prop="sellAmountTotal" :label="$t('尾巴卖出金额(sol)')">
          </el-table-column>
          <el-table-column prop="netPurchasesTotal" :label="$t('净买入(sol)')">
          </el-table-column>
          <el-table-column prop="hole" :label="$t('单币持有时间（秒）')">
          </el-table-column>
        </el-table>
  
  
        <el-table :data="genDanLogResponseList" v-loading="loading1" :row-style="{ height: '0' }"
                  :cell-style="{ padding: '5px' }" border class="table-left">
          <el-table-column width="600px" :label="$t('钱包地址')">
            <template slot-scope="scope">
                          <span :style="{ color: scope.row.fromAddress == tempWaller ? 'red' : 'black' }">
                              {{ scope.row.fromAddress }}
                          </span>
            </template>
          </el-table-column>
  
          <el-table-column prop="type" :label="$t('类型')">
          </el-table-column>
  
          <el-table-column prop="format" :label="$t('时间')">
          </el-table-column>
  
          <el-table-column prop="num" :label="$t('金额(sol)')">
          </el-table-column>
  
          <el-table-column prop="hash" :label="$t('hash')">
            <template slot-scope="scope">
              <a :href="`https://solscan.io/tx/${scope.row.hash}`" target="_blank" :class="'link-color'">
                {{ 'HASH' }}
              </a>
            </template>
          </el-table-column>
        </el-table>
  
      </el-dialog>
  
  
  
      <el-dialog :visible.sync="devLogShow1" width="1500px" center close-on-click-modal v-if="devLogShow1">
        <div class="tables-container table-bottom">
          <el-table :data="genDanLogResponseList" v-loading="loading2" :row-style="{ height: '0' }"
                    :cell-style="{ padding: '5px' }" border class="table-left">
            <el-table-column width="600px" :label="$t('钱包地址')">
              <template slot-scope="scope">
                              <span :style="{ color: scope.row.fromAddress == tempWaller ? 'red' : 'black' }">
                                  {{ scope.row.fromAddress }}
                              </span>
              </template>
            </el-table-column>
  
            <el-table-column prop="type" :label="$t('类型')">
            </el-table-column>
  
            <el-table-column prop="format" :label="$t('时间')">
            </el-table-column>
  
            <el-table-column prop="num" :label="$t('金额(sol)')">
            </el-table-column>
  
            <el-table-column prop="hash" :label="$t('hash')">
              <template slot-scope="scope">
                <a :href="`https://solscan.io/account/${scope.row.fromAddress}?remove_spam=true&exclude_amount_zero=true&flow=in&token_address=So11111111111111111111111111111111111111111#transfers`" target="_blank" :class="'link-color'">
                  {{ 'HASH' }}
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
  
    </div>
  </template>
  
  <script>
  
  export default {
    name: "mouse",
    data() {
      return {
        ws: null,
        devLogShow: false,
        devLogShow1: false,
        loading: false,
        loading1: false,
        loading2: false,
        tempWaller: '',
        genDanResponseList: [],
        genDanLogResponseList: [],
        genDanList: [],
        tipList: [],
        devList: [],
        socketStatus: 'disconnected'
      };
    },
    mounted() {
      //this.connect();
      this.initWebSocket();  
    },
    methods: {
        initWebSocket() {
          this.connect();
          // 定期检查连接状态
        setInterval(() => {
          if (this.ws && this.ws.readyState === 1) {
            this.socketStatus = 'connected';
          } else if (this.ws && this.ws.readyState === 0) {
            this.socketStatus = 'connecting';
          } else {
            this.socketStatus = 'disconnected';
            this.connect();
          }
        }, 5000);
      },
      connect() {
        this.ws = new WebSocket('ws://localhost:8080/ws'); // 替换为你的WebSocket服务器地址
  
        this.ws.onopen = () => {
          this.socketStatus = 'connected';
        };
  
        this.ws.onmessage = (event) => {
          var obj = JSON.parse(event.data);
          if (obj.type == 0) {
            this.genDanList.unshift(obj);
          } else if (obj.type == 1) {
            this.tipList.unshift(obj);
          } else if (obj.type == 2) {
            this.devList.unshift(obj);
          }
        };
        this.ws.onerror = (error) => {
          this.socketStatus = 'disconnected';
        };
        this.ws.onclose = () => {
          this.socketStatus = 'disconnected';
        };
      },
      sendMessage() {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send('Hello Server!');
        } else {
          console.error('WebSocket is not open.');
        }
      },
      copyValue(symbol) {
        this.$message({
          message: this.$t("Copy successful"),
          type: "success",
          duration: 500,
        });
        navigator.clipboard
          .writeText(symbol)
          .then(function () { })
          .catch(function (err) { });
      },
      cleanGenDanLog() {
        this.genDanList = [];
      },
      cleanTipLog() {
        this.tipList = [];
      },
      cleanDevLog() {
        this.devList = [];
      },
      fetchData(address, ca) {
        this.loading1 = true;
        this.tempWaller = address;
        this.$axios
          .get("/api/genDanLog/" + address.trim() + "/" + ca.trim())
          .then((successResponse) => {
            this.genDanLogResponseList = successResponse.data;
            this.loading1 = false;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading1 = false;
            // 处理失败响应
          });
      },
      fetchDataV2(address, ca) {
        this.loading2 = true;
        this.devLogShow1 = true;
        this.tempWaller = address;
        this.$axios
          .get("/api/genDanLog/" + address.trim() + "/" + ca.trim())
          .then((successResponse) => {
            this.genDanLogResponseList = successResponse.data;
            this.loading2 = false;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading2 = false;
            // 处理失败响应
          });
      },
      fetchDataV1(e, index) {
        this.devLogShow = true;
        this.loading = true;
        this.tempWaller = e;
        this.genDanList[index].isRead = 1;
        this.$axios
          .get("/api/genDan/" + e.trim())
          .then((successResponse) => {
            this.genDanResponseList = successResponse.data;
            this.loading = false;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading = false;
            // 处理失败响应
          });
      },
      deleteGenDanList(index) {
        if (index > -1) {
          this.genDanList.splice(index, 1);
        }
      },
      deleteTipList(index) {
        if (index > -1) {
          this.tipList.splice(index, 1);
        }
      },
      deleteDevList(index) {
        if (index > -1) {
          this.devList.splice(index, 1);
        }
      },
      getBackgroundColor(ca) {
        // 获取前两个字符
        const prefix = ca.slice(0, 2);
  
        // 计算前两个字符的 ASCII 码进行累加
        let charSum = 0;
        for (let char of prefix) {
          charSum += char.charCodeAt(0);
        }
  
        // 取模运算，确保在 0 到 59 的范围，以提供更多颜色
        const mod = charSum % 60;
  
        // 使用 HSL 颜色模型生成颜色
        const hue = (mod * 6) % 360; // 每 6 度一个颜色，确保均匀分布
        const saturation = 70 + (mod % 30); // 饱和度在 70% 到 100% 之间，以增加变化
        const lightness = 40 + (mod % 30); // 亮度在 40% 到 70% 之间，以增加变化
  
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`; // 返回 HSL 颜色
      },
      getSameCaColor(ca, list) {
        // 判断当前 tipList 的 ca 是否在 genDanList 中存在
        const isCaExistInGenDan = list.some(item => item.ca === ca);
        if (isCaExistInGenDan) {
          return this.getBackgroundColor(ca); // 如果存在，设置底色
        }
        return null;
      },
      getSameCaTip(ca){
        // 判断当前 tipList 的 ca 是否在 genDanList 中存在
        const foundItem = this.tipList.find(item => item.ca === ca);
        if (foundItem) {
          return parseFloat(foundItem.amount).toFixed(2); // 返回数字
        } else {
          return '';
        }
      },
    },
    isConditionMet(fromAddress) {
      return true;
    }
  };
  </script>
  
  <style scoped>
  .tables-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .link-color {
    color: #409eff;
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    margin-left: 30px;
  }
  
  .el-icon-arrow-down {
    font-size: 12px;
  }
  
  .el-icon-sunny {
    font-size: 25px;
    margin-left: 20px;
  }
  
  .el-icon-moon {
    font-size: 25px;
    margin-left: 20px;
  }
  
  .el-icon-s-promotion {
    margin-left: 25px;
    font-size: 30px;
  }
  
  .box-three {
    margin: 30px 0;
  }
  
  .table-left {
    margin-right: 15px;
  }
  
  .table-bottom {
    margin-bottom: 30px;
  }
  
  .remarkSave {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
  }
  
  .box {
    display: flex;
  }
  
  .box-column-center {
    justify-content: center;
  }
  
  .box-center {
    justify-content: center;
    align-items: center;
  }
  
  .text-red {
    color: red;
  }
  
  .color-round {
    width: 16px; /* 设置宽度 */
    height: 16px; /* 设置高度 */
    display: inline-block; /* 显示为块元素 */
    margin-right: 5px; /* 与文本之间的间距 */
    border-radius: 50%; /* 圆形 */
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Monitor.vue